import { Stack } from '@mui/material';
import { styled } from '@mui/system';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import Button from '@mui/material/Button';

export const Wrapper = styled(Stack)`
  align-items: center;
  gap: 8px;
  min-height: 30px;
  padding: 4px;
  overflow: hidden;
  cursor: pointer;

  :hover,
  &.focused {
    background: #f3f5f6;
    border-radius: 4px;
  }

  > .delete-button {
    width: 0;
  }
  :hover > .delete-button {
    width: 20px;
  }
`;

export const Title = styled(Body2)`
  flex: 1;
  color: #000;
`;

export const DeleteButton = styled(Button)`
  border-radius: 4px;
  padding: 0;
  margin: 0;
  transition: width 200ms;
`;
